import { render } from "./CompanyManagement.vue?vue&type=template&id=02884484"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"

import "./CompanyManagement.vue?vue&type=style&index=0&id=02884484&lang=scss"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__